// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"95f454d8","206":"c8cd9c98","694":"95f454d8","695":"43f8c5dc","819":"95f454d8","841":"d8ee40b1"}[chunkId] + ".chunk.css";
};